<style scoped>
  .expand-row{
    margin-bottom: 16px;
  }
</style>
<template>
  <div>
    <Row class="expand-row">
      <div v-for="(item, res) in row" v-bind:key="res">
        <Col span="8">
          <span class="expand-key">{{ res }}：</span>
          <span class="expand-value">{{ item }}</span>
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
export default {
  name: 'table-expand',
  props: {
    row: Object
  }
}
</script>
